import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="w-full font-montserrat relative overflow-hidden bg-[#0E0B09]">

      {/* 🎨 Fondo tipo brush difuminado */}
      <div className="absolute inset-0 z-0">

        {/* Mancha 1 */}
        <motion.div
          className="absolute w-[500px] h-[500px] rounded-full blur-[120px] opacity-30"
          style={{
            background: "radial-gradient(circle, #3C2B22 0%, transparent 70%)",
          }}
          animate={{
            x: [0, 80, -40, 0],
            y: [0, -60, 40, 0],
          }}
          transition={{
            duration: 18,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />

        {/* Mancha 2 */}
        <motion.div
          className="absolute w-[600px] h-[600px] rounded-full blur-[140px] opacity-20"
          style={{
            background: "radial-gradient(circle, #7A5E50 0%, transparent 70%)",
          }}
          animate={{
            x: [-100, 40, -60, -100],
            y: [50, -80, 30, 50],
          }}
          transition={{
            duration: 22,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />

        {/* Mancha 3 */}
        <motion.div
          className="absolute w-[400px] h-[400px] rounded-full blur-[100px] opacity-20"
          style={{
            background: "radial-gradient(circle, #1C1410 0%, transparent 70%)",
          }}
          animate={{
            x: [60, -50, 30, 60],
            y: [-40, 60, -20, -40],
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      </div>

      {/* CONTENIDO */}
      <div
        className="
          relative
          z-10
          max-w-6xl
          mx-auto
          px-6
          py-10
          flex
          flex-col
          md:flex-row
          justify-between
          items-center
          gap-6
        "
      >

        {/* MARCA */}
        <div className="text-center md:text-left">
          <h3
            className="
              text-[#B8977F]
              text-lg
              md:text-xl
              font-semibold
              tracking-wide
            "
          >
            {t("footer.name")}
          </h3>

          <p className="text-[#7A5E50] text-sm mt-1">
            {t("footer.location")}
          </p>
        </div>

        {/* TAGLINE */}
        <div className="text-center max-w-xl">
          <p
            className="
              text-[#D4BCAA]
              text-sm
              md:text-base
              italic
              font-light
              leading-relaxed
            "
          >
            <span className="block md:inline">
              {t("footer.tagline1")}
            </span>{" "}
            <span className="block md:inline">
              {t("footer.tagline2")}
            </span>
          </p>
        </div>

        {/* SOCIAL + DERECHOS */}
        <div className="text-center md:text-right">
          <p
            className="
              text-[#B8977F]
              text-sm
              hover:text-[#EDE0D0]
              transition
              duration-300
              cursor-pointer
            "
          >
            {t("footer.instagram")}
          </p>

          <p className="text-[#7A5E50] text-xs mt-2">
            &copy; {new Date().getFullYear()} {t("footer.rights")}
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;